"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstanceMethodNames = void 0;
// below helper methods sourced from:
// http://code.fitness/post/2016/01/javascript-enumerate-methods.html
function hasMethod(obj, name) {
    const desc = Object.getOwnPropertyDescriptor(obj, name);
    return !!desc && typeof desc.value === "function";
}
function getInstanceMethodNames(obj, stop) {
    const array = [];
    let proto = Object.getPrototypeOf(obj);
    while (proto && proto !== stop) {
        Object.getOwnPropertyNames(proto).forEach(name => {
            if (name !== "constructor") {
                if (hasMethod(proto, name)) {
                    array.push(name);
                }
            }
        });
        proto = Object.getPrototypeOf(proto);
    }
    return array;
}
exports.getInstanceMethodNames = getInstanceMethodNames;
//# sourceMappingURL=getInstanceMethodNames.js.map